module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/xthor4-47ec4559840e2cc2d16b424a047f734c.jpg";